var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10,6H6v4H4V6H0V4H4V0H6V4h4Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }